import React, { useState, useCallback, useRef } from 'react';
import type { FormProps, } from 'antd';
import { notification } from 'antd';
import { Button, Form, Input } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import { CONSTANT, EMAIL, NOTIFICATION_TYPE } from '../constants/index';
import emailjs from '@emailjs/browser';
import { throttle } from 'lodash';

emailjs.init({ publicKey: EMAIL.publicKey });

type FieldType = {
  username?: string;
  tel?: string;
};

const useStyles = makeStyles(() => ({
  contact: {
    padding: '42px 50px',
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    '& h1': {
      fontSize: 42,
      margin: 0
    },
    '& h2': {
      fontSize: 24,
      marginTop: 12,
      fontWeight: 200
    },
    '& h3': {
      fontSize: 14,
      color: '#999',
      margin: '12px 0 6px 0'
    },
    '& h4': {
      fontSize: 24,
      color: 'red',
      margin: 0
    },
  },
  form: {
    height: 72,
    width: '100%',
    '& input': {
      height: 46,
      minWidth: 320
    },
    '& .ant-form-item-control': {
      margin: 0,
      '& button': {
        height: 46,
        width: 120,
        lineHeight: '37px'
      }
    },
    '@media (max-width: 1260px)': {
      height: 'auto',
      flexDirection: 'column',
      '& .ant-form-item': {
        marginBottom: 24,
        '& div': {
          width: '100% !important',
          maxWidth: 'none',
          '& .ant-btn': {
            width: '100% !important'
          }
        }
      } 
    },
  }
}));

const ContactComponent: React.FC = () => {
  const classes = useStyles();
  const formRef = useRef(null);
  const [isSending, setIsSending] = useState(false);

  const [Notification, contextHolder] = notification.useNotification({
    stack: { threshold: 1 }
  });

  const sendEmail = useCallback((msg: { username: string; tel: string }) => {
    setIsSending(true);
    emailjs
      .send(EMAIL.serviceKey, EMAIL.templateKey, msg)
      .then(
        () => {
          setIsSending(false);
          Notification[NOTIFICATION_TYPE.SUCCESS]({
            message: '发送成功',
            description: '已收到您的信息，我们会尽快联系您',
          })
          // @ts-ignore
          formRef.current?.resetFields();
        },
        () => {
          setIsSending(false);
          Notification[NOTIFICATION_TYPE.ERROR]({
            message: '发送失败',
            description: '服务异常，请稍后再试',
          })
        }
      )
  }, [Notification])

  const onFinish: FormProps<FieldType>['onFinish'] = throttle(useCallback((value: any) => {
    const { username, tel } = value;
    if (username && tel) {
      sendEmail(value);
    }
  }, [sendEmail]), 5000);
  
  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = useCallback(() => {
    setIsSending(false);
  }, []);

  return (
    <div className={classes.contact}>
      {contextHolder}
      <h1>咨询详细方案</h1>
      <h2>免费获得 1v1 详细解答，留下您的联系方式，我们会尽快联系您</h2>
      <div className={classes.form}>
        <Form
          ref={formRef}
          layout='inline'
          autoComplete="off"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className={classes.form}
        >
          <Form.Item<FieldType>
            name="username"
            rules={[{ required: true, message: '请输入您的称呼!' }]}
          >
            <Input placeholder='称呼' />
          </Form.Item>
          <Form.Item<FieldType>
            name='tel'
            rules={[{ required: true, message: '请输入您的电话!' }]}
          >
            <Input placeholder='电话' />
          </Form.Item>
          <Form.Item label={null}>
            <Button type="primary" htmlType="submit" disabled={isSending}>
              { isSending ? '发送中' : '立即申请' }
            </Button>
          </Form.Item>
        </Form>
      </div>
      <h3>或致电我们24小时热线，让我们为您服务</h3>
      <h4>{CONSTANT.tel}</h4>
      <h4>{CONSTANT.phone}</h4>
     </div>
  );
};

export default ContactComponent;